import type { Registration } from '../models/registration.model';
import { httpService } from './httpService';
import { ListItem } from '../models/ListItem';
import GenericService from './genericService';
import { environment } from '../environments/environment.development';

class SignupService extends GenericService<Registration, ListItem> {
    constructor() {
        super('/api/Account');
    }

    async registerUser(data: Registration): Promise<void> {
        try {
            await httpService.post<void>(`${environment.baseURL}/api/Account/Register`, data);
        } catch (error) {
            console.error('Error during user registration:', error);
            throw new Error('User registration failed. Please try again later.');
        }
    }
}

export const signupService = new SignupService();
